// 9fbef606107a605d69c0edbcd8029e5d

export const FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST = 'FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST';
export const FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS = 'FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS';
export const FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE = 'FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE';
export const FETCH_SHOP_BY_LOOK_UNBXD_REQUEST = 'FETCH_SHOP_BY_LOOK_UNBXD_REQUEST';
export const FETCH_SHOP_BY_LOOK_UNBXD_SUCCESS = 'FETCH_SHOP_BY_LOOK_UNBXD_SUCCESS';
export const FETCH_SHOP_BY_LOOK_UNBXD_FAILURE = 'FETCH_SHOP_BY_LOOK_UNBXD_FAILURE';
